__turbopack_context__.v({
  "content": "section-of-press-banners-module-scss-module__nYaz_W__content",
  "link": "section-of-press-banners-module-scss-module__nYaz_W__link",
  "logo": "section-of-press-banners-module-scss-module__nYaz_W__logo",
  "logos": "section-of-press-banners-module-scss-module__nYaz_W__logos",
  "responsive-image": "section-of-press-banners-module-scss-module__nYaz_W__responsive-image",
  "section": "section-of-press-banners-module-scss-module__nYaz_W__section",
});
